import { FailedToLoad } from '@ms/yammer-error-components';
import { useTranslations } from '@ms/yammer-i18n-react';
import ErrorStrings from '@ms/yammer-strings/dist/Error';
import React, { FC, useEffect } from 'react';

interface UserActivationAutoRefreshProps {
  readonly timeoutMs?: number;
}

const UserActivationAutoRefresh: FC<UserActivationAutoRefreshProps> = ({ timeoutMs = 8000 }) => {
  const t = useTranslations(ErrorStrings);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload();
    }, timeoutMs);

    return () => clearTimeout(timer);
  }, [timeoutMs]);

  return <FailedToLoad title={t.bootstrapErrorUserActivationTitle()} error={t.bootstrapErrorUserActivationMessage()} />;
};

export default UserActivationAutoRefresh;
